import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NEWS_LIST } from '../../shared/data/news-data';

@Component({
    selector: 'app-news-details',
    templateUrl: './news-details.component.html',
    styleUrls: ['./news-details.component.scss']
})
export class NewsDetailsComponent implements OnInit {
    newsId: number | null = null;
    newsItem: any;

    constructor(private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.newsId = Number(params.get('id'));
            this.newsItem = NEWS_LIST.find(item => item.id === this.newsId);
        });
    }
}
